exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row-expand-cover .el-table__expand-icon {\n    visibility: hidden;\n}\n", ""]);

// exports
